export default __webpack_public_path__ + "static/media/voltar.8372b695.svg";